import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260429_remove_dead_viewfilter_categories",
  description: "Removes dead view filter categories: mask and hoveredRoom",
  apply(json: any) {
    json.planViews = json.planViews ?? {};
    for (const id of Object.keys(json.planViews)) {
      migrateViewFilter(json.planViews[id].viewFilter);
    }
    json.view3Ds = json.view3Ds ?? {};
    for (const id of Object.keys(json.view3Ds)) {
      migrateViewFilter(json.view3Ds[id].viewFilter);
    }
    json.elevationViews = json.elevationViews ?? {};
    for (const id of Object.keys(json.elevationViews)) {
      migrateViewFilter(json.elevationViews[id].viewFilter);
    }
    json.sectionViews = json.sectionViews ?? {};
    for (const id of Object.keys(json.sectionViews)) {
      migrateViewFilter(json.sectionViews[id].viewFilter);
    }
    return json;
  },
};

/** All views: delete outdated fields mask and hoveredRoom. */
function migrateViewFilter(viewFilter: any) {
  if (viewFilter === undefined) {
    return;
  }
  if (viewFilter.mask !== undefined) {
    delete viewFilter.mask;
  }
  if (viewFilter.hoveredRoom !== undefined) {
    delete viewFilter.hoveredRoom;
  }
}

export default migration;
